angular.module('iconoglobe')
    .factory('CategoryFilterService', function ($q, $http) {
        var siteBaseUrl = window.location.protocol + "//" + window.location.host;
        var parentCat;
        var getSubCat = function (catId, stateId) {
            var deferred = $q.defer();
            var params = {
                'stateId': stateId,
                'catId': catId
            };
            $http.post('/data/getcategory', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject();
                });
            return deferred.promise;
        };
        var getSubcategoriesOfCategory = function (catId) {
            var deferred = $q.defer();
            var params = {
                'catId': catId
            };
            $http.post('/api/getSubcategoriesOfCategory', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };
        var getChildCatsOrGenresOfSubCategory = function (subCatId) {
            var deferred = $q.defer();
            var params = {
                'subCatId': subCatId
            };
            $http.post('/api/getChildCatsOrGenresOfSubcategory', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };
        var getGenresOfChildCategory = function (childCatId) {
            var deferred = $q.defer();
            var params = {
                'childCatId': childCatId
            };
            $http.post('/api/getGenresOfChildCategory', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };
        var getMenuHierarchy = function (catName, subCatName, childCatName, genreName) {
            var deferred = $q.defer();
            var params = {
                catName: catName,
                subCatName: subCatName,
                childCatName: childCatName,
                genreName: genreName
            };
            $http.post('/api/getMenuHierarchy', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        };
        var getGenre = function (subCatId, stateId) {
            var deferred = $q.defer();
            var params = {
                'stateId': stateId,
                'subCatId': subCatId
            };
            $http.post('/data/getsubcategory', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject();
                });
            return deferred.promise;
        };
        var getChildCat = function (id) {
            var deferred = $q.defer();
            var params = {
                'subCatId': id
            };
            $http.post('/data/getChildCat', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject();
                });
            return deferred.promise;
        };
        var getParentCat = function () {
            var deferred = $q.defer();
            if (parentCat) {
                deferred.resolve(parentCat);
            }
            ;
            $http.get('/api/getcategories')
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (err) {
                    console.log(err);
                });
            return deferred.promise;
        };
        var getAllGenre = function () {
            var deferred = $q.defer();
            $http.get('/api/genres/getallgenres')
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject();
                });
            return deferred.promise;
        };
        var getGenreBySubcat = function (subCatId) {
            var deferred = $q.defer();
            var params = {
                'subCatId': subCatId
            };
            $http.post('/data/getChildCat', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject();
                });
            return deferred.promise;
        };
        var getSubCatByCatId = function (catId) {
            var deferred = $q.defer();
            var params = {
                'catId': catId
            };
            $http.post('/data/getcategory', params)
                .then(function (res) {
                    deferred.resolve(res.data);
                }, function (error) {
                    deferred.reject();
                });
            return deferred.promise;
        };
        return {
            getSubCat: getSubCat,
            getGenre: getGenre,
            getChildCat: getChildCat,
            getParentCat: getParentCat,
            getAllGenre: getAllGenre,
            getSubCatByCatId: getSubCatByCatId,
            getGenreBySubcat: getGenreBySubcat,
            getSubcategoriesOfCategory: getSubcategoriesOfCategory,
            getChildCatsOrGenresOfSubCategory: getChildCatsOrGenresOfSubCategory,
            getGenresOfChildCategory: getGenresOfChildCategory,
            getMenuHierarchy: getMenuHierarchy
        };
    });